angular.module( 'acme.view.application.themes.donation.modals.deactivate', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.themes.donation.modals.deactivate.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var themesDonationModalsDeactivate = {
        name: 'application.themes.donation.modals.deactivate',
        url: '/themes/donation/modals/deactivate',
        views: {
          "main": {
            controller: 'ThemesDonationModalsDeactivateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/themes/donation/modals/deactivate/deactivate.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(themesDonationModalsDeactivate);
});
